module.exports = __webpack_public_path__ + "img/serve1.41245349.png";